import axios from 'axios';

// Define an axios client. Uses relative URLs so requests hit the same origin
// the bundle was served from — Vue's dev proxy forwards /api in dev, and prod
// serves frontend + backend from the same host.
export const defineClient = (url = '', headers = {}) => {
    return axios.create({
        baseURL: url || '',
        headers: headers,
    });
};

// Build a same-origin URL that proxies to VUE_APP_WEBSITE_URL via the backend.
// Accepts either an absolute URL on the website host or a path starting with "/".
export const websiteProxyUrl = (urlOrPath) => {
    const base = (process.env.VUE_APP_WEBSITE_URL || '').replace(/\/$/, '');
    let path = urlOrPath || '';
    if (base && path.startsWith(base)) {
        path = path.slice(base.length);
    } else if (/^https?:\/\//i.test(path)) {
        const u = new URL(path);
        path = u.pathname + u.search + u.hash;
    }
    if (!path.startsWith('/')) path = '/' + path;
    return `/api/website-proxy?path=${encodeURIComponent(path)}`;
};

 // Handle errors gracefully if necessary
 export const handleError = (error) => {
    if (error.response) {
        // The request was made, and the server responded with a status code outside of 2xx range
        console.error('API Error Response:', error.response.data);
    } else if (error.request) {
        // The request was made but no response was received
        console.error('API No Response:', error.request);
    } else {
        // Something happened in setting up the request
        console.error('API Error Setup:', error.message);
    }
}